{
  "LOGIN": {
    "TITLE": "Είσοδος στο Κέντρο Επικοινωνίας",
    "EMAIL": {
      "LABEL": "Email",
      "PLACEHOLDER": "example{'@'}companyname.com",
      "ERROR": "Παρακαλώ εισάγετε μια έγκυρη διεύθυνση email"
    },
    "PASSWORD": {
      "LABEL": "Κωδικός",
      "PLACEHOLDER": "Κωδικός"
    },
    "API": {
      "SUCCESS_MESSAGE": "Επιτυχής είσοδος",
      "ERROR_MESSAGE": "Αδυναμία σύνδεσης με τον Woot Server, Παρακαλώ προσπαθήστε αργότερα",
      "UNAUTH": "Το όνομα χρήστη ή ο κωδικός δεν είναι σωστός. Παρακαλώ ξαναπροσπαθήστε",
      "ACCOUNT_DEACTIVATED": "Ο λογαριασμός σας έχει απενεργοποιηθεί. Παρακαλώ επικοινωνήστε με τον διαχειριστή σας.",
      "PASSWORD_LOGIN_DISABLED": "Η σύνδεση με κωδικό πρόσβασης είναι απενεργοποιημένη για τον λογαριασμό σας. Παρακαλώ συνδεθείτε μέσω OAuth (π.χ. Google)."
    },
    "OAUTH": {
      "GOOGLE_LOGIN": "Login with Google",
      "BUSINESS_ACCOUNTS_ONLY": "Please use your company email address to login",
      "NO_ACCOUNT_FOUND": "We couldn't find an account for your email address."
    },
    "FORGOT_PASSWORD": "Ξεχάσατε τον κωδικό;",
    "CREATE_NEW_ACCOUNT": "Δημιουργία νέου Λογαριασμού",
    "SUBMIT": "Είσοδος"
  }
}
